/**
 * Каталог стиль-паков ЦЕЛИКОМ — для кабинета (галерея «Стиль», редактор,
 * предпросмотр) и тестов. Порядок — порядок галереи.
 *
 * WEB-2534: данные паков лежат по файлу на пак в `stylePackData/`, а публичная
 * страница покупателя этот файл НЕ импортирует — она берёт пак своей воронки
 * лениво через `loadStylePack` (`stylePacks.ts`). Кабинет кладёт весь каталог в
 * реестр на своём входе (`src/main.tsx` → `registerAllStylePacks`), поэтому
 * для него всё по-прежнему синхронно и ничего не ждёт.
 *
 * Совпадение множеств «список id ↔ загрузчики ↔ файлы ↔ этот каталог» держит
 * сторож `themes/__tests__/stylePackLazy.web2534.test.ts`.
 */
import type { StylePack } from './stylePack.types';
import { registerStylePack } from './stylePacks';
import { pack as softRounded } from './stylePackData/soft-rounded';
import { pack as warmCream } from './stylePackData/warm-cream';
import { pack as cleanWhite } from './stylePackData/clean-white';
import { pack as flatSharp } from './stylePackData/flat-sharp';
import { pack as cinematicPhoto } from './stylePackData/cinematic-photo';
import { pack as darkMystic } from './stylePackData/dark-mystic';
import { pack as editorialSerif } from './stylePackData/editorial-serif';
import { pack as monoGlam } from './stylePackData/mono-glam';
import { pack as brightPop } from './stylePackData/bright-pop';
import { pack as pastelSerif } from './stylePackData/pastel-serif';
import { pack as techMint } from './stylePackData/tech-mint';
import { pack as productPremium } from './stylePackData/product-premium';
import { pack as blueGradient } from './stylePackData/blue-gradient';
import { pack as surveyForm } from './stylePackData/survey-form';
import { pack as outlinePills } from './stylePackData/outline-pills';
import { pack as framedCenter } from './stylePackData/framed-center';
import { pack as leftSoft } from './stylePackData/left-soft';
import { pack as plainList } from './stylePackData/plain-list';
import { pack as stepForm } from './stylePackData/step-form';

export const STYLE_PACKS: StylePack[] = [
  softRounded,
  warmCream,
  cleanWhite,
  flatSharp,
  cinematicPhoto,
  darkMystic,
  editorialSerif,
  monoGlam,
  brightPop,
  pastelSerif,
  techMint,
  productPremium,
  blueGradient,
  surveyForm,
  outlinePills,
  framedCenter,
  leftSoft,
  plainList,
  stepForm,
];

/** Положить весь каталог в реестр — вход кабинета и обвязка тестов. */
export function registerAllStylePacks(): void {
  for (const pack of STYLE_PACKS) registerStylePack(pack);
}
